import React from "react";

import SearchableSelect from "../../../../components/SearchableSelect";

interface StreamDelaySelectProps {
  value: number | string;
  onChange: (value: number | string) => void;
}

const delayOptions = [{ label: "No Delay", value: "0" }].concat(
  Array.from({ length: 60 }, (_, index) => ({
    label: `${index + 1} Minute${index === 0 ? "" : "s"}`,
    value: `${index + 1}`,
  })),
);

const getDelayLabel = (value: number | string) => {
  if (value === 0 || value === "0") return "No Delay";
  if (value) return `${value} Minutes`;

  return "";
};

const StreamDelaySelect: React.FC<StreamDelaySelectProps> = ({
  value,
  onChange,
}) => (
  <div>
    <label
      htmlFor="delay-select"
      className="text-sm font-medium text-gray-600 mb-2 block"
    >
      Delay (Minutes)
    </label>
    <SearchableSelect
      placeholder="Select Delay"
      searchPlaceholder="Search delay..."
      options={delayOptions}
      value={{
        value: value || "",
        label: getDelayLabel(value),
      }}
      onChange={(option: any) => onChange(option?.value || "")}
    />
  </div>
);

export default StreamDelaySelect;
